import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, InputLabel, MenuItem, Popover, Select, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import Button from '../../button';
import { Avatar } from '../../atoms/Avatar';
import styles from './UserMenuPopover.styles';

const UserMenuPopover = ({ classes, menuItemClassName, currentUser, locale, onChangeLocale, onLogout }) => {
  const anchorEl = useRef(null);
  const [open, setOpen] = useState(false);

  return (
    <>
      <div ref={anchorEl}>
        <Button onClick={() => setOpen(!open)} color="primary" aria-haspopup="true" className={menuItemClassName}>
          <Avatar responsible={currentUser.name} size="small" />
        </Button>
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl.current}
        onClose={() => setOpen(false)}
        transitionDuration={{ enter: 0, exit: 0 }}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            borderRadius: 4,
            overflow: 'visible'
          }
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box className={classes.root}>
          <Box className={classes.userInfo}>
            <Avatar responsible={currentUser.name} size="medium" />
            <Box className={classes.userInfo_texts}>
              <Typography variant="body2" className={classes.userInfo_name}>
                {currentUser.name}
              </Typography>
              <Typography variant="caption" className={classes.userInfo_email}>
                {currentUser.email}
              </Typography>
            </Box>
          </Box>

          <Box className={classes.languageRow}>
            <InputLabel>
              <FormattedMessage id="language" defaultMessage="Idioma" />:
            </InputLabel>
            <Select value={locale} onChange={onChangeLocale}>
              <MenuItem value="es">Español</MenuItem>
              <MenuItem value="en">English</MenuItem>
            </Select>
          </Box>

          <Divider />

          <Button onClick={onLogout} className={classes.menuItem}>
            <FormattedMessage id="logout" defaultMessage="Salir" />
          </Button>
        </Box>
      </Popover>
    </>
  );
};

UserMenuPopover.propTypes = {
  classes: PropTypes.object.isRequired,
  menuItemClassName: PropTypes.string,
  currentUser: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string
  }).isRequired,
  locale: PropTypes.string.isRequired,
  onChangeLocale: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired
};

export default withStyles(styles)(UserMenuPopover);
